import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ObjectTypes } from '@fi-shared/types';
import { FiAccessRightFiltersManualSelectionBaseDirective } from '@fi-shared/access-right-filters/access-right-filters-manual-selection/fi-access-right-filters-manual-selection-base.directive';

@Component({
    selector: 'fi-access-rights-manual-selection-roles',
    template: `
        <fi-checkbox2
            [item]="itemsListData"
            [(ngModel)]="ngModel"
            (ngModelChange)="onSelectionChange()"
            [canChangeChecked]="canChangeAccessRight.bind(this)"
            [disableIds]="getDisabledItemIds()"
        />
    `,
    styleUrls: ['./fi-access-rights-manual-selection-roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-access-rights-manual-selection-roles' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiAccessRightsManualSelectionRolesComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiAccessRightsManualSelectionRolesComponent,
        },
    ],
    standalone: false,
})
export class FiAccessRightsManualSelectionRolesComponent extends FiAccessRightFiltersManualSelectionBaseDirective {
    ObjectType: ObjectTypes = ObjectTypes.Role;

    doValidate(): ValidationErrors {
        return { 'roles-not-selected': this.required && !this.ngModel.length };
    }
}
